import { put, takeLatest, call } from 'redux-saga/effects';

import {getOrganisationSuccess, getUserOrganisationSuccess} from '../actionCreators/organisationActions';
import {GET_ORGANISATION_REQUEST, GET_USER_ORGANISATION_REQUEST} from '../constants/actionTypes';
import { OrganisationApi } from '../api';
import errorHandler from '../utils/requestErrorHandler';

function* getUserOrganisation(action) {
  try {
    const data = yield call(OrganisationApi.getUserOrganisation, action.payload);

    yield put(getUserOrganisationSuccess(data));
  } catch (error) {
    yield errorHandler(error);
  }
}

function* getOrganisation(action) {
  try {
    const data = yield call(OrganisationApi.getOrganisation, action.payload.id);

    yield put(getOrganisationSuccess(data));
  } catch (error) {
    yield errorHandler(error);
  }
}

export default function* watchChallenge() {
  yield takeLatest(GET_USER_ORGANISATION_REQUEST, getUserOrganisation);
  yield takeLatest(GET_ORGANISATION_REQUEST, getOrganisation);
}
